// components
import React from 'react'

import 'core-js/stable/symbol'
import 'core-js/stable/symbol/iterator'
import 'core-js/es/promise'
import 'core-js/es/string/raw'
import 'core-js/es/string/ends-with'
import 'core-js/es/string/starts-with'
import 'core-js/es/string/iterator'
import 'core-js/es/string/replace-all'
import 'core-js/es/array/find'
import 'core-js/es/array/map'
import 'core-js/es/array/reduce'
import 'core-js/es/array/reverse'
import 'core-js/es/array/some'
import 'core-js/es/array/values'
import 'core-js/es/array/concat'
import 'core-js/es/array/every'
import 'core-js/es/array/flat'
import 'core-js/es/array/index-of'
import 'core-js/es/array/find-index'
import 'core-js/es/array/from'
import 'core-js/es/object/keys'
import 'core-js/es/object/assign'
import 'core-js/es/object/to-string'
import 'core-js/es/typed-array'
import 'core-js/es/date'
import 'core-js/es/regexp'

import 'regenerator-runtime/runtime'
import 'custom-event-polyfill'
import loadable from '@loadable/component'
import {
  constants,
  hydrate,
  createDocomoUrl,
  CommonTranslations
} from '@pmi/pmi-iqos-shared-react'

const fallback = <div className="loading loading-lg" />
const context = 'zyn'

const AVConversion = loadable(
  () =>
    import(/* webpackChunkName: "AVConversion" */ './components/av-conversion'),
  { fallback }
)
const BazaarVoiceReview = loadable(
  () =>
    import(
      /* webpackChunkName: "BazaarVoiceReview" */ './components/bazaar-voice-review'
    ),
  { fallback }
)
const Cart = loadable(
  () => import(/* webpackChunkName: "Cart" */ './components/cart'),
  { fallback }
)
const Checkout = loadable(
  () => import(/* webpackChunkName: "Checkout" */ './components/checkout'),
  { fallback }
)
const DeviceRegistration = loadable(
  () =>
    import(
      /* webpackChunkName: "DeviceRegistration" */ './components/device-registration'
    ),
  { fallback }
)
const IlumaImmersion = loadable(
  () =>
    import(
      /* webpackChunkName: "IlumaImmersion" */ './components/iluma-immersion'
    ),
  {
    fallback
  }
)
const ImageSharing = loadable(
  () =>
    import(/* webpackChunkName: "ImageSharing" */ './components/image-sharing'),
  { fallback }
)
const Login = loadable(
  () => import(/* webpackChunkName: "Login" */ './components/login'),
  { fallback }
)
const Logout = loadable(
  () => import(/* webpackChunkName: "Logout" */ './components/logout'),
  { fallback }
)
const MarketplaceOrder = loadable(
  () =>
    import(
      /* webpackChunkName: "MarketplaceOrder" */ './components/marketplace-order'
    ),
  { fallback }
)
const OCR = loadable(
  () => import(/* webpackChunkName: "OCR" */ './components/ocr'),
  { fallback }
)
const OrderConfirmation = loadable(
  () =>
    import(
      /* webpackChunkName: "OrderConfirmation" */ './components/order-confirmation'
    ),
  { fallback }
)
const Player3D = loadable(
  () => import(/* webpackChunkName: "Player3D" */ './components/player-3d'),
  { fallback }
)
const ProductBundleDetail = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductBundleDetail" */ './components/product-bundle-detail'
    ),
  { fallback }
)
const ProductBundleList = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductBundleList" */ './components/product-bundle-list'
    ),
  { fallback }
)
const ProductDetail = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductDetail" */ './components/product-detail'
    ),
  { fallback }
)
const ProductDetailMulti = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductDetailMulti" */ './components/product-detail-multi'
    ),
  { fallback }
)
const ProductDetailMultiMCP = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductDetailMultiMCP" */ './components/product-detail-multi-mcp'
    ),
  { fallback }
)
const ProductLineUp = loadable(
  () =>
    import(
      /* webpackChunkName: "ProductLineUp" */ './components/product-line-up'
    ),
  { fallback }
)
const ProductList = loadable(
  () =>
    import(/* webpackChunkName: "ProductList" */ './components/product-list'),
  { fallback }
)
const ProfileAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileAccount" */ './components/profile-account'
    ),
  { fallback }
)
const ProfileCoupons = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileCoupons" */ './components/profile-coupons'
    ),
  { fallback }
)
const ProfileDevices = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileDevices" */ './components/profile-devices'
    ),
  { fallback }
)
const ProfileOrders = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileOrders" */ './components/profile-orders'
    ),
  { fallback }
)
const ProfileSocialAccounts = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileSocialAccounts" */ './components/profile-social-accounts'
    ),
  { fallback }
)
const ProfileTobaccoDelivery = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileTobaccoDelivery" */ './components/profile-tobacco-delivery'
    ),
  { fallback }
)
const ProfilesLoginCallback = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfilesLoginCallback" */ './components/profiles-login-callback'
    ),
  { fallback }
)
const ProfilesNewCallback = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfilesNewCallback" */ './components/profiles-new-callback'
    ),
  { fallback }
)
const ProfileGfDashboard = loadable(
  () =>
    import(
      /* webpackChunkName: "ProfileGfDashboard" */ './components/profile-gf-dashboard'
    ),
  { fallback }
)
const Qure = loadable(
  () => import(/* webpackChunkName: "Qure" */ './components/qure'),
  { fallback }
)
const QureUpgradeOffer = loadable(
  () =>
    import(
      /* webpackChunkName: "QureUpgradeOffer" */ './components/qure-upgrade-offer'
    ),
  { fallback }
)
const Register = loadable(
  () => import(/* webpackChunkName: "Register" */ './components/register'),
  { fallback }
)
const RegistrationConfirm = loadable(
  () =>
    import(
      /* webpackChunkName: "RegistrationConfirm" */ './components/registration-confirm'
    ),
  { fallback }
)
const RegistrationThankYou = loadable(
  () =>
    import(
      /* webpackChunkName: "RegistrationThankYou" */ './components/registration-thank-you'
    ),
  { fallback }
)
const ResetPassword = loadable(
  () =>
    import(
      /* webpackChunkName: "ResetPassword" */ './components/reset-password'
    ),
  { fallback }
)
const ScanDevice = loadable(
  () => import(/* webpackChunkName: "ScanDevice" */ './components/scan-device'),
  { fallback }
)
const SubscriptionProductList = loadable(
  () =>
    import(
      /* webpackChunkName: "SubscriptionProductList" */ './components/subscription-product-list'
    ),
  { fallback }
)
const TermsPopup = loadable(
  () => import(/* webpackChunkName: "TermsPopup" */ './components/terms-popup'),
  { fallback }
)
const ContactForm = loadable(
  () =>
    import(/* webpackChunkName: "ContactForm" */ './components/contact-form'),
  { fallback }
)

// translations
const AVConversionTranslations = require('./components/av-conversion/av-conversion.json')
const BazaarVoiceReviewTranslations = require('./components/bazaar-voice-review/bazaar-voice-review.json')
const CartTranslations = require('./components/cart/cart.json')
const CheckoutTranslations = require('./components/checkout/checkout.json')
const DeviceRegistrationTranslations = require('./components/device-registration/device-registration.json')
const IlumaImmersionTranslations = require('./components/iluma-immersion/iluma-immersion.json')
const ImageSharingTranslations = require('./components/image-sharing/image-sharing.json')
const LoginTranslations = require('./components/login/login.json')
const LogoutTranslations = require('./components/logout/logout.json')
const MarketplaceOrderTranslations = require('./components/marketplace-order/marketplace-order.json')
const OCRTranslations = require('./components/ocr/ocr.json')
const OrderConfirmationTranslations = require('./components/order-confirmation/order-confirmation.json')
const Player3DTranslations = require('./components/player-3d/player-3d.json')
const ProductBundleDetailTranslations = require('./components/product-bundle-detail/product-bundle-detail.json')
const ProductBundleListTranslations = require('./components/product-bundle-list/product-bundle-list.json')
const ProductDetailTranslations = require('./components/product-detail/product-detail.json')
const ProductDetailMultiTranslations = require('./components/product-detail-multi/product-detail-multi.json')
const ProductDetailMultiMCPTranslations = require('./components/product-detail-multi-mcp/product-detail-multi-mcp.json')
const ProductLineUpTranslations = require('./components/product-line-up/product-line-up.json')
const ProductListTranslations = require('./components/product-list/product-list.json')
const ProfileAccountTranslations = require('./components/profile-account/profile-account.json')
const ProfileCouponsTranslations = require('./components/profile-coupons/profile-coupons.json')
const ProfileDevicesTranslations = require('./components/profile-devices/profile-devices.json')
const ProfileGfDashboardTranslations = require('./components/profile-gf-dashboard/profile-gf-dashboard.json')
const ProfileOrdersTranslations = require('./components/profile-orders/profile-orders.json')
const ProfileSocialAccountsTranslations = require('./components/profile-social-accounts/profile-social-accounts.json')
const ProfileTobaccoDeliveryTranslations = require('./components/profile-tobacco-delivery/profile-tobacco-delivery.json')
const ProfilesLoginCallbackTranslations = require('./components/profiles-login-callback/profiles-login-callback.json')
const ProfilesNewCallbackTranslations = require('./components/profiles-new-callback/profiles-new-callback.json')
const QureTranslations = require('./components/qure/qure.json')
const QureUpgradeOfferTranslations = require('./components/qure-upgrade-offer/qure-upgrade-offer.json')
const RegisterTranslations = require('./components/register/register.json')
const RegistrationConfirmTranslations = require('./components/registration-confirm/registration-confirm.json')
const RegistrationThankYouTranslations = require('./components/registration-thank-you/registration-thank-you.json')
const ResetPasswordTranslations = require('./components/reset-password/reset-password.json')
const ScanDeviceTranslations = require('./components/scan-device/scan-device.json')
const SubscriptionProductListTranslations = require('./components/subscription-product-list/subscription-product-list.json')
const TermsPopupTranslations = require('./components/terms-popup/terms-popup.json')
const ContactFormTranslations = require('./components/contact-form/contact-form.json')

export default {
  components: {
    AVConversion,
    BazaarVoiceReview,
    Cart,
    Checkout,
    DeviceRegistration,
    IlumaImmersion,
    ImageSharing,
    Login,
    Logout,
    MarketplaceOrder,
    OCR,
    OrderConfirmation,
    Player3D,
    ProductBundleDetail,
    ProductBundleList,
    ProductDetail,
    ProductDetailMulti,
    ProductDetailMultiMCP,
    ProductLineUp,
    ProductList,
    ProfileAccount,
    ProfileCoupons,
    ProfileDevices,
    ProfileGfDashboard,
    ProfileOrders,
    ProfileSocialAccounts,
    ProfileTobaccoDelivery,
    ProfilesLoginCallback,
    ProfilesNewCallback,
    Qure,
    QureUpgradeOffer,
    Register,
    RegistrationConfirm,
    RegistrationThankYou,
    ResetPassword,
    ScanDevice,
    SubscriptionProductList,
    TermsPopup,
    ContactForm
  },
  translations: {
    AVConversion: AVConversionTranslations,
    BazaarVoiceReview: BazaarVoiceReviewTranslations,
    Cart: CartTranslations,
    Checkout: CheckoutTranslations,
    Common: CommonTranslations,
    DeviceRegistration: DeviceRegistrationTranslations,
    IlumaImmersion: IlumaImmersionTranslations,
    ImageSharing: ImageSharingTranslations,
    Login: LoginTranslations,
    Logout: LogoutTranslations,
    MarketplaceOrder: MarketplaceOrderTranslations,
    OCR: OCRTranslations,
    OrderConfirmation: OrderConfirmationTranslations,
    Player3D: Player3DTranslations,
    ProductBundleDetail: ProductBundleDetailTranslations,
    ProductBundleList: ProductBundleListTranslations,
    ProductDetail: ProductDetailTranslations,
    ProductDetailMulti: ProductDetailMultiTranslations,
    ProductDetailMultiMCP: ProductDetailMultiMCPTranslations,
    ProductLineUp: ProductLineUpTranslations,
    ProductList: ProductListTranslations,
    ProfileAccount: ProfileAccountTranslations,
    ProfileCoupons: ProfileCouponsTranslations,
    ProfileDevices: ProfileDevicesTranslations,
    ProfileGfDashboard: ProfileGfDashboardTranslations,
    ProfileOrders: ProfileOrdersTranslations,
    ProfileSocialAccounts: ProfileSocialAccountsTranslations,
    ProfileTobaccoDelivery: ProfileTobaccoDeliveryTranslations,
    ProfilesLoginCallback: ProfilesLoginCallbackTranslations,
    ProfilesNewCallback: ProfilesNewCallbackTranslations,
    Qure: QureTranslations,
    QureUpgradeOffer: QureUpgradeOfferTranslations,
    Register: RegisterTranslations,
    RegistrationConfirm: RegistrationConfirmTranslations,
    RegistrationThankYou: RegistrationThankYouTranslations,
    ResetPassword: ResetPasswordTranslations,
    ScanDevice: ScanDeviceTranslations,
    SubscriptionProductList: SubscriptionProductListTranslations,
    TermsPopup: TermsPopupTranslations,
    ContactForm: ContactFormTranslations
  },
  hydrate,
  version: process.env.VERSION,
  cdnReactDistUrl: constants.CDN_REACT_DIST_URL + '/' + context,
  utils: {
    createDocomoUrl
  }
}
